import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import gksLogo from 'assets/img/gksLogo.png';

import PoweredBy from 'components/PoweredBy/PoweredBy';
import BuiltOnEnkrateia from 'components/BuiltOnEnkrateia/BuiltOnEnkrateia';
import Markdown from 'components/Markdown/Markdown';
import { useSystemSettings } from 'providers/SystemSettingsProvider';

import './Splash.scss';

export interface SplashProps {
  children?: ReactNode;
}

const Splash: FC<SplashProps> = ({ children }) => {
  const { t } = useTranslation();
  const { splash_image, splash_text } = useSystemSettings();

  return (
    <div className="enkrateia-splash" style={{ backgroundImage: `url(${splash_image})` }}>
      <div className="splash-overlay" />
      <div className="content">
        {children ?? (
          <Markdown linkTarget="_blank" className="cta">
            {splash_text}
          </Markdown>
        )}
      </div>
      <div className="footer">
        <BuiltOnEnkrateia />
        <img src={gksLogo} alt={t('pages.login.gksLogo') as string} width={80} />
        <PoweredBy />
      </div>
    </div>
  );
};

export default Splash;
